import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styles from "./Popup.module.css";
import dayjs from "dayjs";
import { authData } from "../GetAuth";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

const AddmembershipCustomerForm = ({ id, setAddMembershipModalShow, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [membershipList, setMembershipList] = useState([]);
  const [selectmembership, setSelectmembership] = useState([]);
  const [expireddate, setExpireddate] = useState("");

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      membership_id: ""
    }
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/membership-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        let itemData = response.data.data;
        setMembershipList(itemData);
      }
    });
  }, [API_TOKEN]);

  const getMember = (event) => {
    let selItem = membershipList.filter((i) => i.value === event);
    if (selItem.length) {
      setSelectmembership(selItem[0]);
      let expdate = selItem[0].duration.split(" ");
      let cur_date1 = dayjs().add(expdate[0], expdate[1]);
      setExpireddate(cur_date1.format("DD/MM/YYYY"));
    }
  }

  const onSubmitLocal = (data) => {
    if (id) {
      data.customer_id = id;
    }
    if (selectmembership?.duration) {
      data.duration = selectmembership?.duration;
    }
    const postData = data;
    setLoading(true);
    setAddMembershipModalShow(false);

    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/add-membership/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/add-membership", postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData(response.data.data);
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  }

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      Add Membership
      <IconButton onClick={(e) => setAddMembershipModalShow(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupFull}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Membership*</InputLabel>
              <Controller
                control={control}
                {...register("membership_id", {
                  required: "This field is Required",
                })}
                render={({ field }) => (<Select
                  {...field}
                  label="Membership*"
                  onChange={(e) => {
                    field.onChange(e);
                    getMember(e.target.value);
                  }}
                >
                  {membershipList?.map((i) => {
                    return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
                  })}
                </Select>)}
              />
            </FormControl>
            {errors.membership_id && (<span className={`${styles.ErrorM}`}>{errors?.membership_id?.message}</span>)}
          </div>
          {(selectmembership?.duration || selectmembership?.price || selectmembership?.discount) && (<div className={`${styles.FormGroupFull}`} style={{ display: "flex", flexWrap: "wrap", gap: "6px 24px" }}>
            {selectmembership?.duration && (<label className={`${styles.FormLabel}`}>Duration : <strong>{selectmembership?.duration}</strong></label>)}
            {selectmembership?.price && (<label className={`${styles.FormLabel}`}>Price : <strong>&pound;{selectmembership?.price}</strong></label>)}
            {selectmembership?.discount && (<label className={`${styles.FormLabel}`}>Discount : <strong>{selectmembership?.discount}%</strong></label>)}
            {selectmembership?.duration && (<label className={`${styles.FormLabel}`}>Expired : <strong>{expireddate}</strong></label>)}
          </div>)}
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setAddMembershipModalShow(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">{editData ? "Update" : "Add"}</Button>
        </div>
      </form>
    </DialogContent>
  </>);
};

export default AddmembershipCustomerForm;